import React, {useMemo} from 'react';
import { Segment } from 'tea-component';
import './index.scss';

export default function DateTypeSegment(props: any) {
	
  const { value, onChange, isEn, className='', ...reset } = props;
  const options = useMemo(() => [
    {value: 'hour', text: isEn ? 'Hour' : '小时'},
    {value: 'day', text: isEn ? 'Day' : '日'},
    {value: 'week', text: isEn ? 'Week' : '周'},
    {value: 'month', text: isEn ? 'Month' : '月'},
  ], [isEn]);
  return (<Segment
    className={`datalab-date-type-segment ${className}`}
    options={options}
    value={value}
    onChange={onChange}
    {...reset}
  />);
}